import React, { useState, useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import ImageSlider from '../components/ImageSlider';
import CategorySection from '../components/CategorySection';
import CustomSection from '../components/CustomSection';
import './HomePage.css';

const HomePage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '/api';
      const response = await fetch(`${apiUrl}/products`);
      const data = await response.json();
      setProducts(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching products:', error);
      setLoading(false);
    }
  };

  return (
    <div className="home-page">
      <ImageSlider />
      
      <CategorySection />

      {/* Our Collection */}
      <section className="section products-section" id="products">
        <div className="container">
          <h2 className="section-title">Our Collection</h2>
          <p className="section-subtitle">Discover our latest designs</p>
          
          {loading ? (
            <div className="loading">Loading products...</div>
          ) : (
            <div className="products-grid grid grid-4">
              {products.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      </section>

      <CustomSection />
    </div>
  );
};

export default HomePage;
